module.exports = __webpack_public_path__ + "static/media/Portrait-10024_original.ba087957.jpg";